import React from 'react'
import paypalQrImg from './qrcode.png'
const PaypalQrCode = () => {
  return (
    <div>
<img src={paypalQrImg} alt="QR Code for Paypal payment" className='mlot'></img>



    </div>
  )
}

export default PaypalQrCode